import {Stack} from "@mui/material";
import FaIcon from "./fa-icon";
import {useTheme} from "@mui/material/styles";

export default function CommentStars({stars}: { stars: number }) {
    const theme = useTheme()

    return (
        <Stack direction = "row-reverse" spacing = {1} justifyContent="flex-end" >
            {[5, 4, 3, 2, 1].map((i) => (
                <FaIcon
                    fontSize = {18}
                    key = {i}
                    color = {i <= stars ? theme.palette.secondary.main : theme.palette.primary.main}
                    variant={i <= stars ? "solid" : "light"}
                    faIcon = "fa-star"
                />
            ))}
        </Stack >
    );
}
